export default "__VITE_ASSET__Dza_XJZr__"